import React from 'react';
interface HeroSectionProps {
  handlePurchase: () => void;
}
export function HeroSection({
  handlePurchase
}: HeroSectionProps) {
  return <section className="relative px-4 sm:px-[5%] py-12 md:py-20 flex flex-col items-center text-center overflow-hidden min-h-[80vh] sm:min-h-[90vh] justify-center" role="banner" data-id="element-144">
      {/* Background — Neural Network */}
      <div className="absolute inset-0 z-0 opacity-40 transition-opacity duration-1000" style={{
      backgroundImage: "url('https://cdn.shopify.com/s/files/1/0981/0781/8286/files/El_Hero_Visual_Fondo_de_red_neuronal.png?v=1775547360')",
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} aria-hidden="true" data-id="element-145" />

      {/* Gradient overlay — fades edges into dark bg */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0B] via-transparent to-[#0A0A0B] z-[1]" aria-hidden="true" data-id="element-146" />

      {/* Content */}
      <div className="relative z-10 max-w-4xl w-full animate-fadeInUp" data-id="element-147">
        <span className="inline-block bg-yellow-500/10 text-[#D4AF37] px-3 sm:px-4 py-1.5 rounded-full text-[9px] sm:text-[10px] font-black tracking-[2px] sm:tracking-[3px] mb-4 sm:mb-6 uppercase border border-yellow-500/20" data-id="element-148">
          OFERTA DE ACCESO INMEDIATO
        </span>

        <h1 className="font-serif text-[2.5rem] sm:text-5xl md:text-7xl lg:text-8xl leading-[1.1] font-black mb-4 sm:mb-6" data-id="element-149">
          <span className="text-white" data-id="element-150">PROGRAMACIÓN</span> <br data-id="element-151" />
          <span className="text-[#D4AF37]" data-id="element-152">NEURO-CUÁNTICA</span>
        </h1>

        <p className="text-base sm:text-lg md:text-xl opacity-90 leading-relaxed mb-6 sm:mb-8 max-w-2xl mx-auto font-medium px-2" data-id="element-153">
          Sintoniza tu sistema nervioso con la frecuencia de la abundancia y
          elimina bloqueos de escasez en 15 minutos.
        </p>

        <div className="flex flex-col items-center gap-3 sm:gap-4" data-id="element-154">
          <button onClick={handlePurchase} className="bg-[#D4AF37] text-black py-4 sm:py-6 px-8 sm:px-12 text-base sm:text-xl font-black rounded-xl shadow-[0_20px_60px_rgba(212,175,55,0.4)] hover:scale-105 transition-all w-full max-w-xs sm:max-w-md active:scale-95" data-id="element-155">
            DECRETO MI ABUNDANCIA AHORA
          </button>

          {/* Banner — Ver todo lo que incluye */}
          <button onClick={() => {
          const el = document.getElementById('hoy-te-llevas');
          if (el) {
            el.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
            setTimeout(() => {
              el.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
            }, 600);
          }
        }} className="border border-[#D4AF37]/40 bg-[#D4AF37]/10 text-[#D4AF37] py-2.5 sm:py-3 px-6 sm:px-8 rounded-lg text-xs sm:text-sm font-black uppercase tracking-[1.5px] sm:tracking-[2px] hover:bg-[#D4AF37]/20 transition-all cursor-pointer" data-id="element-156">
            VER TODO LO QUE INCLUYE →
          </button>

          <p className="text-[9px] sm:text-[10px] font-bold text-[#D4AF37] tracking-[2px] sm:tracking-[3px] uppercase" data-id="element-157">
            ⚡ ACCESO DIGITAL • PAGO ÚNICO
          </p>
          <div className="flex flex-col items-center gap-1 text-[9px] sm:text-[10px] font-bold tracking-[1.5px] text-[#D4AF37]/60 mt-1" data-id="element-158">
            <p data-id="element-159">🔒 Pago 100% seguro con PayPal y tarjeta</p>
            <p data-id="element-160">✅ Garantía de devolución de 30 días sin preguntas</p>
          </div>
        </div>
      </div>

      {/* Product Image — Manual */}
      <div className="mt-10 sm:mt-16 relative z-10 w-full flex justify-center" data-id="element-161">
        <img src="https://cdn.shopify.com/s/files/1/0981/0781/8286/files/baby-365-7424892.png?v=1775591799" srcSet="https://cdn.shopify.com/s/files/1/0981/0781/8286/files/baby-365-7424892.png?v=1775591799&width=280 280w, https://cdn.shopify.com/s/files/1/0981/0781/8286/files/baby-365-7424892.png?v=1775591799&width=350 350w, https://cdn.shopify.com/s/files/1/0981/0781/8286/files/baby-365-7424892.png?v=1775591799&width=450 450w" sizes="(max-width: 640px) 280px, (max-width: 1024px) 350px, 480px" alt="EL CÓDIGO 888" width={480} height={620} className="w-full max-w-[280px] sm:max-w-[350px] md:max-w-[480px] drop-shadow-[0_50px_100px_rgba(0,0,0,0.9)] animate-float" loading="eager" decoding="async" fetchPriority="high" data-id="element-162" />
      </div>
    </section>;
}